import Vue from 'vue'
import VueRouter from 'vue-router'
import {sharedRoutes} from "@/shared/sharedRoutes";


Vue.use(VueRouter)


let routes = [];

routes = [
        {path: '/', component: () => import("../pages/StudentDashboard")},
        {path: '/course-registration', component: () => import("../pages/CourseRegistration.vue")},
        {path: '/results', component: () => import("../pages/ResultsPage.vue")},
        {path: '/fees', component: () => import("../pages/SchoolFees.vue")},
        {path: '/biodata', component: () => import("../pages/BioData.vue")},
        {path: '/settings', component: () => import("../pages/ProfileSettingsPage")},
        {path: '/accommodation', component: () => import("../pages/Accomodation.vue")},
        {path: '/programme', component: () => import("../pages/ChangeProgramme.vue")},
        {path: '/student_document', component: () => import("../pages/StudentDocument")},
        {path: '/verify', component: () => import("../pages/Verification.vue")},
        {path: '/other_fees', component: () => import("@ui/student/pages/OtherFees.vue")},
        {path: '/clearance', component: () => import("../pages/Clearance.vue")},
        {path: '/notification', component: () => import("../pages/NotificationPage.vue")},
        {path: '/time-table', component: () => import("../pages/TimetablePage.vue")},
        {path: '/support', component: () => import("../pages/SupportPage.vue")},
        {path: '/my-courses', component: () => import("../pages/StudentCoursesPage.vue")},
        {path: '/wallet', component: () => import("../pages/WalletPage.vue")},
        // shared routes
        ...sharedRoutes,
        {path: '*', component: () => import("../../pages/NotFound.vue")}
]


export default new VueRouter({
        routes: routes
        // mode: 'history'
})
